import React from 'react';
import { CtaButton } from './CtaButton';
import { navLinks } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function TopBar() {
  return <header className="sticky top-0 z-50 w-full border-b border-ivory/10 bg-forest-dark/95 backdrop-blur" data-id="element-178" data-mp="1y3sosxsbcz4b">
      <div className="mx-auto flex h-14 w-full md:h-16 max-w-content items-center justify-between gap-6 px-5 md:px-8" data-id="element-179" data-mp="1t4plpivw92yz">
        <a href="#top" className="whitespace-nowrap font-serif text-lg font-semibold text-ivory md:text-xl" data-id="element-180" data-mp="2qsr8hzc349bq">
          {siteConfig.wordmark}
        </a>

        <div className="flex items-center gap-8" data-id="element-181" data-mp="2h2es8jbaz2be">
          <nav aria-label="Main" className="hidden md:block" data-id="element-182" data-mp="2h13o2idy3sjr">
            <ul className="flex items-center gap-7" data-id="element-183" data-mp="2c4d8dw61yyyv">
              {navLinks.map(link => <li key={link.href} data-id="element-184" data-mp="39jhe3vt1ia8a">
                  <a href={link.href} className="inline-flex min-h-11 items-center text-[15px] font-medium text-ivory/80 transition-colors duration-150 ease-out hover:text-ivory" data-id="element-185" data-mp="39kk13sn8rsix">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <CtaButton tone="onDark" size="compact" className="hidden sm:inline-flex" data-id="element-186" data-mp="3olbzlf25thee" />
        </div>
      </div>
    </header>;
}